var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5.78126L14.8 4.82149C14.1005 4.08679 13.2588 3.5021 12.3262 3.103C11.3935 2.7039 10.3894 2.49874 9.375 2.50001C5.23438 2.50001 1.875 5.85938 1.875 10C1.875 14.1406 5.23438 17.5 9.375 17.5C10.9262 17.4999 12.4392 17.0191 13.7058 16.1237C14.9725 15.2283 15.9305 13.9623 16.448 12.5",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1228 3.80653V8.12606C18.1228 8.29182 18.0569 8.45079 17.9397 8.568C17.8225 8.68521 17.6635 8.75106 17.4978 8.75106H13.1783C12.6212 8.75106 12.3423 8.07801 12.7361 7.68426L17.056 3.36434C17.4497 2.96981 18.1228 3.2495 18.1228 3.80653Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLineIcon);
export default __webpack_public_path__ + "static/media/refresh-line-icon.f00fe27eb0ceb3a0252c45e0a89c8458.svg";
export { ForwardRef as ReactComponent };